// components/RegistrationWizard/Success.jsx
import React from "react";

export default function Success() {
  return (
    <div className="success-wrap">
      <header className="banner">
        <div className="brand">
          <div className="logo" />
          <div className="title">Hugarafl Skráning</div>
        </div>
      </header>
      <main className="success">
        <h1>Félagsaðild</h1>
        <div className="bubble">
          <p><strong>Velkomin/n/ð í Hugarafl!</strong></p>
          <p>Næsta skref er að sækja um aðgang að Facebookhópnum Hugaraflsfólk þar sem þú getur nálgast allar upplýsingar um starfsemina, séð dagskránna og margt fleira. Hringdu í s: 414 1550 eða sendu email á hugarafl@hugarafl.is ef eitthvað er óljóst.</p>
        </div>
      </main>
    </div>
  );
}